import { render, staticRenderFns } from "./MainButtonDecorRightSmall.vue?vue&type=template&id=abdc2b6c"
import script from "./MainButtonDecorRightSmall.vue?vue&type=script&lang=js"
export * from "./MainButtonDecorRightSmall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports